// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b38aab34","703":"51613092"}[chunkId] + ".chunk.js";
};